'use client';
import { useState, useMemo } from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect.js';
import { ROOT_CLASSNAMES } from '../../core/constants/globals.js';

/**
 * checks if a element is wrapped inside the element with the standard mode or not
 * refElement - element
 * ancestorElement - element with dark/compact mode
 */ function hasNestedStandardMode(element, ancestorElement) {
    let currentElement = element === null || element === void 0 ? void 0 : element.parentElement;
    while(currentElement && currentElement !== ancestorElement){
        if (currentElement.className.includes(ROOT_CLASSNAMES.standardMode)) {
            return true;
        }
        currentElement = currentElement.parentElement;
    }
    return false;
}
function setMode(elementRef, callback, mode) {
    var _elementRef_current;
    const closestCompactModeElem = (_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.closest(`.${ROOT_CLASSNAMES[mode]}`);
    if (closestCompactModeElem) {
        const hasNestedStandardModeElem = hasNestedStandardMode(elementRef.current, closestCompactModeElem);
        callback(!hasNestedStandardModeElem);
    } else {
        // in case mode is switched from compact to standard at a later time
        callback(false);
    }
}
/**
 * The hook accepts a ref to an element and optional param to force a re-evaluation of mode object.
 * returns a object containing two boolean properties
 * - `hasDarkMode`: whether the element is currently in dark mode.
 * - `hasCompactMode`: whether the element is currently in compact mode.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function useModeExtractor(elementRef, retrigger) {
    const [hasDarkMode, setHasDarkMode] = useState(false);
    const [hasCompactMode, setHasCompactMode] = useState(false);
    useIsomorphicLayoutEffect(()=>{
        setMode(elementRef, setHasDarkMode, 'darkMode');
        setMode(elementRef, setHasCompactMode, 'compactMode');
    }, [
        elementRef,
        retrigger
    ]);
    const modes = useMemo(()=>({
            hasDarkMode,
            hasCompactMode
        }), [
        hasDarkMode,
        hasCompactMode
    ]);
    return modes;
}

export { hasNestedStandardMode, useModeExtractor };
